import store from "../store";
import router from "../router";

// 格式化菜单
export function fmtMenu(data: Record<any, any>, route: Record<any, any> = {}) {
  const routes: Record<any, any> = {};
  router.getRoutes().forEach((item: Record<any, any>) => {
    routes[item.name] = item;
  });
  const titles: Record<any, any> = {};
  const parents: Record<any, any> = {};
  const selected: Record<any, any> = [];
  tfMenu(data, routes, titles, parents, "", selected, route);
  const opened: Record<any, any> = [];
  if (selected.length > 0) {
    tfSelected(selected[0], parents, opened);
  }
  opened.reverse();
  return { data, titles, selected, opened };
}

// 生成菜单
function tfMenu(
  data: Record<any, any>,
  routes: Record<any, any>,
  titles: Record<any, any>,
  parents: Record<any, any>,
  parent: string,
  selected: Record<any, any>,
  route: Record<any, any>
) {
  data.forEach((item: Record<any, any>, idx: number) => {
    if (routes[item.name] !== undefined) {
      const label =
        item.label !== undefined ? item.label : routes[item.name].meta.title;
      item.key = item.key !== undefined ? item.key : item.name;
      item.icon = routes[item.name].meta.icon;
      item.title = label;
      item.params = item.params !== undefined ? item.params : {};
      titles[item.key] = label;
      if (parent !== "") {
        parents[item.key] = parent;
      }
      if (Object.keys(route).length > 0) {
        if (
          (routes[item.name].meta.dynamic !== true &&
            route.name === item.name) ||
          (routes[item.name].meta.dynamic === true &&
            route.name === item.name &&
            item.name + Object.values(route.params).join("") == item.key)
        ) {
          selected[0] = item.key;
        }
      }
      if (item.children && item.children.length > 0) {
        tfMenu(
          item.children,
          routes,
          titles,
          parents,
          item.key,
          selected,
          route
        );
      }
    } else {
      data.splice(idx, 1);
    }
  });
}

// 生成打开数组
function tfSelected(
  select: string,
  parents: Record<any, any>,
  opened: Record<any, any>
) {
  const nSelect = parents[select];
  if (nSelect) {
    opened.push(nSelect);
    tfSelected(nSelect, parents, opened);
  }
}

// 格式化权限
export function fmtPermission(tree: Record<any, any>, data: Record<any, any>) {
  const permission: Record<any, any> = tfPermission(tree, data);
  return permission;
}

// 生成权限
function tfPermission(tree: Record<any, any>, data: Record<any, any>) {
  const treeData: Record<any, any> = JSON.parse(JSON.stringify(tree));
  const permission: Record<any, any> = [];
  treeData.forEach((item: Record<any, any>) => {
    if (item.children && item.children.length > 0) {
      item.children = tfPermission(item.children, data);
    }
    if (
      data.indexOf(item.key) >= 0 ||
      (item.children && item.children.length > 0)
    ) {
      permission.push(item);
    }
  });
  return permission;
}

// 获取根目录
export function getBase() {
  return process.env.BASE_URL;
}
